import type { ApplicantScopedKeyArguments } from "./callScriptShared.types";

export type CallScriptKeyArguments = ApplicantScopedKeyArguments;

export const callScriptKeys = {
  all: ["callScript"] as const,
  history: (arguments_: CallScriptKeyArguments) => [...callScriptKeys.all, "history", arguments_] as const,
  questions: (approvalId: string, type: string) => [...callScriptKeys.all, "questions", approvalId, type] as const,
};

/**
 * True for query keys produced by `callScriptKeys.questions`, false for
 * `callScriptKeys.history` (or anything else) — the question catalog is
 * reference data scoped to the deal's vintage (approvalId), safe to persist
 * to storage, call history is applicant-specific and must not be.
 * @param {ReadonlyArray<unknown>} queryKey - A TanStack Query cache entry's key.
 * @returns {boolean} Whether the key belongs to the question catalog.
 */
export function isCallScriptQuestionsQueryKey(queryKey: readonly unknown[]): boolean {
  return queryKey[0] === callScriptKeys.all[0] && queryKey[1] === "questions";
}
